import { buildUrl } from 'hub-http/helpers/url';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
export const getAvatarSrc = emailHash => {
  if (!emailHash) {
    return '';
  }
  return buildUrl({
    hostname: resolveApi(hubletApi('api', 'hubspot')),
    path: `/userpreferences/v1/avatar/${emailHash}/100`
  });
};